import React, { useState, ChangeEvent, useEffect, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { GeneralContext } from '~/contexts';
import api from '~/services/api';
import './styles.css';

// Components
import { InputLabel } from '~/components/Parts/Forms';

// Images
import logo from '~/assets/images/logo_serena.svg';

// Constants
const initialState = { mail: '' };

const Forgot: React.FC = () => {
	const navigate = useNavigate();
	const { logged } = useContext(GeneralContext);
    const [values, setValues]   = useState(initialState);
    const [message, setMessage] = useState<string>('');
    const [errors, setErrors]   = useState<String[]>([]);

	function onChange(event: ChangeEvent<HTMLInputElement>) {
        const {name, value} = event.target;
        setValues({...values, [name]: value})
    }

	async function onSubmit (event: React.FormEvent<HTMLFormElement>) {
		event.preventDefault();

		if (values.mail==='') {
			var errArr = [];

			if (values.mail==='') errArr.push('O campo de email está vazio');

			setErrors(errArr);
			return;
		}

		await api
			.post('forgot-password', values)
			.then((resp: any) => {
				setErrors([]);
				setValues(initialState);
				setMessage(resp.data.message ?? 'Enviamos um link para o seu e-mail.');
			})
			.catch((err: any) => {
				setMessage('');
				const status = err.response?.status;
				if (status === 400) {
					const error = err.response.data?.errors;
					setErrors(Array.isArray(error) ? error : [String(error ?? 'Não encontramos este e-mail.')]);
				} else if (status === 502) {
					setErrors(['Não foi possível enviar o e-mail. Tente novamente mais tarde ou fale com o suporte.']);
				} else {
					setErrors(['Não foi possível concluir o pedido. Verifique sua conexão e tente novamente.']);
				}
			});
	}

	function treatErrors() {
		return (
			<div className="boxErrors">
				{errors.map((el) => (
					<span key={`error_${el}`}>{el}</span>
				))}
			</div>
		);
	}

    function treatMessage() {
        return (
            <div className="boxMessage">
				{ message }
            </div>
        )
    }

	// Test Navigate
	useEffect(() => {
		if (logged) navigate('/');
	}, [logged, navigate])

	return (
		<div id="forgot">
			<div className='header'>
				<img src={logo} alt="Logo Serena" />

				<h2>Esqueci minha senha</h2>
			</div>

			{ Array.isArray(errors) && errors.length>0 && treatErrors() }
			{ !errors.length && message && treatMessage() }

			<form onSubmit={onSubmit} autoComplete='off' method="POST">
				<InputLabel name='mail' type='mail' labelName='E-mail' value={values.mail} onChange={onChange}/>

				<button className="send" type="submit">
					Enviar link de recuperação
				</button>

				<div className="back">
					<span>Lembrou da senha?</span>

					<Link to="/login" className="dec">
						Voltar ao login
					</Link>
				</div>
			</form>
		</div>
	)
}
export default Forgot
